import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useReOrderChapterQuiz({ courseID }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function reOrder({ chapterID, ...data } = {}) {
    return privateFetch
      .put(`/v1/admin/course/${courseID}/chapters/${chapterID}/quizzes/re-order`, data)
      .then((res) => res.data);
  }

  return useMutation(reOrder, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('chapters-quizzes');
    },
  });
}

export default useReOrderChapterQuiz;
